import { useQuery } from "@tanstack/react-query";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "@/base";
import useUserStore from "@/modules/users/store";

/**
 * Hook para buscar os dados da licenciada ativa
 */
export const useActiveLicenciada = () => {
  const activeLicenciadaId = useUserStore((state) => state.activeLicenciadaId);

  return useQuery({
    queryKey: ["licenciada", activeLicenciadaId],
    queryFn: async (): Promise<TLicenciada | null> => {
      if (!activeLicenciadaId) {
        return null;
      }

      const licenciadaReference = doc(firestore, "licenciadas", activeLicenciadaId);
      const licenciadaSnap = await getDoc(licenciadaReference);

      if (!licenciadaSnap.exists()) {
        return null;
      }

      return licenciadaSnap.data() as TLicenciada;
    },
    enabled: !!activeLicenciadaId,
    staleTime: 1000 * 60 * 5 // 5 minutos
  });
};
